export default async function loadStatusFlowComponent(name) {
  const loaders = {
    KeyCommon: () => import('./KeyCommon.vue'),
    KeyFour: () => import('./KeyFour.vue'),
    KeyFive: () => import('./KeyFive.vue'),
    KeySeven: () => import('./KeySeven.vue'),
    KeyNine: () => import('./KeyNine.vue'),
    KeyTen: () => import('./KeyTen.vue'),
    KeyTwelve: () => import('./KeyTwelve.vue'),
    KeyFourteen: () => import('./KeyFourteen.vue'),
    KeyFifteen: () => import('./KeyFifteen.vue'),
    KeySixteen: () => import('./KeySixteen.vue'),
    KeySeventeen: () => import('./KeySeventeen.vue'),
    KeyTwentySix: () => import('./KeyTwentySix.vue'),
    KeyTwentyEight: () => import('./KeyTwentyEight.vue'),
    KeyThirty: () => import('./KeyThirty.vue'),
    KeyThirtyOne: () => import('./KeyThirtyOne.vue'),
    KeyThirtyThree: () => import('./KeyThirtyThree.vue'),
    KeyTwentyFive: () => import('./KeyTwentyFive.vue'),
    KeyThirtyFive: () => import('./KeyThirtyFive.vue'),
    KeyCustom: () => import('./KeyCustom.vue'),
  }

  const loader = loaders[name]
  if (!loader) {
    throw new Error(`Unknown status-flow component: ${name}`)
  }

  const module = await loader()
  return module.default
}
